'use strict';

export default {
    assignments: []
};
